import { RESET } from '../actionTypes';
import { createTemplateModalActions } from '../reducer';

export default () => createTemplateModalActions[RESET]();
